<template>
    <div id="AssetMaintananceCreate" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading">

        </div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="container-fluid xyz">
                    <div class="page-name">
                        <span id="assetMaintananceHeader" v-if="$route.params.id > 0">Update Asset Maintenance</span>
                        <span id="assetMaintananceHeader" v-else>Add Asset Maintenance</span>
                        <button type="submit" class="btn btn-success waves-effect pull-right back-btn-fl" v-on:click.prevent="BackAssetMaintananceList"  >
                               <i class="hi-icon icon-flback"> </i> Back
                        </button>
                    </div>
                    <div class="admin-page-content">
                        <section class="internal-container border-top-table-fl">
                            <div class="container">
                                <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select asset-main-form" id="AssetMaintananceForm">
                                    <div class="col-md-12">
                                      <div class="row">
                                        <div class="form-group">
                                        <div class="col-xs-12 col-sm-6 col-md-6 col-lg-6">
                                            <label class="control-label col-sm-2 required" for="name">Name:</label>
                                                <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Name" name="name">
                                                <div class="c-error">{{name_error_msg}}</div>
                                        </div>
                                        <!-- <div class="clearfix"></div> -->

                                        <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                                            <label class="control-label col-sm-2 required" for="system">System:</label>
                                                <input type="text" class="form-control" v-model="system" id="system" placeholder="Enter System" name="system">
                                                <div class="c-error">{{system_error_msg}}</div>
                                        </div>

                                        <div class="col-xs-12 col-sm-2 col-md-2 col-lg-2">
                                            <label class="control-label col-sm-2 required" for="assembly">Assembly:</label>
                                                <input type="text" class="form-control" v-model="assembly" id="assembly" placeholder="Enter Assembly" name="assembly">
                                                <div class="c-error">{{assembly_error_msg}}</div>
                                        </div>
                                        <!-- <div class="clearfix"></div> -->

                                        <div class="ccol-xs-12 col-sm-2 col-md-2 col-lg-2">
                                            <label class="control-label col-sm-2 required" for="part">Part:</label>
                                                <input type="text" class="form-control" v-model="part" id="permissable_min" placeholder="Enter Part" name="part">
                                                <div class="c-error">{{part_min_error_msg}}</div>
                                        </div>

                                        <div class="clearfix"></div>

                                        <div class="form-group">
                                            <div class="alert alert-warning hide col-sm-offset-2 col-sm-6" id="alertError">
                                                <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                                <strong id="errorMsg" class="error"></strong>
                                            </div>
                                        </div>

                                        <!-- <div class="form-group"> -->
                                        <div class="col-sm-12 btm-action-btn-fl">

                                            <button type="submit" id="CreateAssetMaintananceBtn" v-if="$route.params.id > 0" class="btn btn-primary nextBtn btn-lg pull-left" v-on:click.prevent="CreateAssetMaintanance" >
                                            <i class="hi-icon icon-flUpdate-data"> </i>  Update
                                            </button>

                                            <button type="submit" id="CreateAssetMaintananceBtn" v-else class="btn btn-primary nextBtn btn-lg pull-left" v-on:click.prevent="CreateAssetMaintanance" >
                                            <i class="hi-icon icon-flSave"> </i>  Save
                                            </button>

                                            <button type="submit" id="createAndContinueAssetMaintananceBtn" v-if="$route.params.id == undefined" class="btn btn-primary nextBtn btn-lg pull-left save-continue-btn" v-on:click.prevent="CreateAssetMaintanance(flag='Save and Continue')" >
                                            <i class="hi-icon icon-flSave-Continue"> </i>  Save and Continue
                                            </button>

                                            <button type="submit" id="cancelAssetMaintananceBtn" class="btn btn-primary nextBtn btn-lg pull-left cancel-btn" v-on:click.prevent="BackAssetMaintananceList" >
                                            <i class="hi-icon icon-flCancel"> </i>  Cancel
                                            </button>

                                        </div>
                                        <!-- </div> -->
                                       </div>
                                      </div>
                                    </div>
                                </form>
                            </div>
                        </section>
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="col-md-12">
                    <div class="error-template">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>
    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';


export default {
  name: "AssetMaintananceCreate",
  mixins:[commonMixins],
  data: () => ({
    permissions: [],
    cantAccessPage: "",
    name: "",
    system: "",
    assembly: "",
    part: "",
    loading:false,
    name_error_msg: "",
    system_error_msg: "",
    assembly_error_msg: "",
    part_min_error_msg: "",
  }),
  watch:{

        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_asset_maintanance_reporting_standards') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
   },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        var path = window.location.pathname;
        var segments = path.split("/");

        if (segments[3]) {
            self.loadAssetMaintanance();
        }
  },
  methods: {
    BackAssetMaintananceList() {
      var self = this;
      self.$router.push("/assetmaintanance/list");
    },

    CreateAssetMaintanance(flag) {
      var self = this;
      var error = false;

      self.name_error_msg = "";
      self.system_error_msg = "";
      self.assembly_error_msg = "";
      self.part_min_error_msg = "";
      self.permissable_max_error_msg = "";

        if (!self.name || self.name == null || self.name == "") {
            self.name_error_msg = "Name Required.";
            error = true;
        }

        if (!self.system || self.system == null || self.system == "") {
            self.system_error_msg = "System Required.";
            error = true;
        }
        if(self.system && !String(self.system).match(/^[0-9]*$/)){
            self.system_error_msg = "System Must be Numeric";
            error = true;
        }

        if (!self.assembly || self.assembly == null || self.assembly == "") {
            self.assembly_error_msg = "Assembly Required.";
            error = true;
        }
        if(self.assembly && !String(self.assembly).match(/^[0-9]*$/)){
            self.assembly_error_msg = "Assembly Must be Numeric";
            error = true;
        }

        if (!self.part || self.part == null || self.part == "") {
            self.part_min_error_msg = "Part Required.";
            error = true;
        }

        if(self.part && !String(self.part).match(/^[0-9]*$/)){
            self.part_min_error_msg = "Part Must be Numeric";
            error = true;
        }

      if (!error) {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#CreateAssetMaintananceBtn").val("Updating ...");
                $("#CreateAssetMaintananceBtn").prop("disabled", true);
                $("#cancelAssetMaintananceBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueAssetMaintananceBtn").val("Saving ...");
                    $("#CreateAssetMaintananceBtn").prop("disabled", true);
                    $("#createAndContinueAssetMaintananceBtn").prop("disabled", true);
                    $("#cancelAssetMaintananceBtn").prop("disabled",true);

                }else{

                    $("#CreateAssetMaintananceBtn").val("Saving ...");
                    $("#CreateAssetMaintananceBtn").prop("disabled", true);
                    $("#createAndContinueAssetMaintananceBtn").prop("disabled", true);
                    $("#cancelAssetMaintananceBtn").prop("disabled",true);
                }

            }

            $.ajax({
                url: process.env.ROOT_API + "/assetmaintanance/create",
                type: "POST",
                data: {
                    name: self.name,
                    id: segments[3],
                    system: self.system,
                    assembly: self.assembly,
                    part: self.part,
                },
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateAssetMaintananceBtn").val("Update");
                        $("#CreateAssetMaintananceBtn").prop("disabled", false);
                        $("#cancelAssetMaintananceBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueAssetMaintananceBtn").val("Save and Continue");
                            $("#CreateAssetMaintananceBtn").prop("disabled", false);
                            $("#createAndContinueAssetMaintananceBtn").prop("disabled", false);
                            $("#cancelAssetMaintananceBtn").prop("disabled",false);

                        }else{

                            $("#CreateAssetMaintananceBtn").val("Save");
                            $("#CreateAssetMaintananceBtn").prop("disabled", false);
                            $("#createAndContinueAssetMaintananceBtn").prop("disabled", false);
                            $("#cancelAssetMaintananceBtn").prop("disabled",false);

                        }
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            $("#AssetMaintananceForm").trigger("reset");
                            self.name ="";
                            self.assembly = "";
                            self.part = "";
                            self.system = "";

                        }else{
                            self.$router.push("/assetmaintanance/list");
                        }

                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#CreateAssetMaintananceBtn").val("Update");
                        $("#CreateAssetMaintananceBtn").prop("disabled", false);
                        $("#cancelAssetMaintananceBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#AssetMaintananceForm").trigger("reset");


                            $("#createAndContinueAssetMaintananceBtn").val("Save and Continue");
                            $("#CreateAssetMaintananceBtn").prop("disabled", false);
                            $("#createAndContinueAssetMaintananceBtn").prop("disabled", false);
                            $("#cancelAssetMaintananceBtn").prop("disabled",false);

                        }else{

                            $("#CreateAssetMaintananceBtn").val("Save");
                            $("#CreateAssetMaintananceBtn").prop("disabled", false);
                            $("#createAndContinueAssetMaintananceBtn").prop("disabled", false);
                            $("#cancelAssetMaintananceBtn").prop("disabled",false);

                        }
                    }
                    if (jqXHR.status == 0) {
                        self.errorMsg = "Remote server cannot be reached";
                    } else {
                        //redirect to login page if user not authenticated
                        if (jqXHR.status == 401) {
                            //clear previous data
                            localStorage.removeItem("user_obj");
                            localStorage.removeItem("tkn");
                            //EventBus.$emit("logged-in", true, "", "");
                            self.$router.push("/");
                        }
                        $("#errorMsg").html(jqXHR.responseJSON.message);
                        $(".alert-warning").toggleClass("show");
                        setTimeout(function () {
                            $(".alert-warning").removeClass("show");
                            $(".alert-warning").addClass("hide");
                        }, 10000);
                    }
                }
            });
      }

    },

    loadAssetMaintanance() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/assetmaintanance/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                if (data.status == "success") {
                    self.name = data.content.name;
                    self.assembly = data.content.assembly;
                    self.system = data.content.system;
                    self.part = data.content.part;
                }
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                if (jqXHR.status == 0) {
                    self.errorMsg = "Remote server cannot be reached";
                } else {
                    //redirect to login page if user not authenticated
                    if (jqXHR.status == 401) {
                        //clear previous data
                        localStorage.removeItem("user_obj");
                        localStorage.removeItem("tkn");
                        //EventBus.$emit("logged-in", true, "", "");
                        self.$router.push("/");
                    }
                    self.error = jqXHR.responseJSON.message;
                }
            }
        });
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/components/AssetMaintananceReportingStandardCreate.vue